import React, { ElementType, ReactElement, ReactNode } from "react";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import styles from "./accordion.module.scss";
import { Minus, Plus } from "@untitled-ui/icons-react";

export const Accordion = (props: AccordionProps): ReactElement => {
  return (
    <div className={styles.contentWrapper}>
      <AccordionPrimitive.Root
        type="multiple"
        className={styles.accordionWrapper}
      >
        {props.accordionItems?.map((item, i) => {
          const TitleIcon = item.icon;
          return (
            <AccordionPrimitive.Item
              key={i}
              value={i + ""}
              className={styles.accordionItem}
            >
              <AccordionPrimitive.Header
                asChild
                className={styles.accordionHeader}
              >
                <AccordionPrimitive.Trigger
                  asChild
                  onClick={() =>
                    item.onCollapseChanged &&
                    item.title &&
                    item.onCollapseChanged(item.title)
                  }
                >
                  <div
                    data-testid={`trigger${i}`}
                    className={styles.accordionTrigger}
                  >
                    <div className={styles.accordionItemTitleWrapper}>
                      {TitleIcon !== undefined && <TitleIcon />}
                      {item.iconUrl && (
                        <img
                          className={styles.iconUrl}
                          src={item.iconUrl}
                          alt=""
                        />
                      )}
                      <p className={styles.accordionItemTitle}>{item.title}</p>
                    </div>
                    <Plus className={styles.plus} />
                    <Minus className={styles.minus} />
                  </div>
                </AccordionPrimitive.Trigger>
              </AccordionPrimitive.Header>

              {item.children ? (
                <AccordionPrimitive.Content
                  className={styles.accordionItemContentWrapper}
                >
                  <>{item.children}</>
                </AccordionPrimitive.Content>
              ) : (
                <AccordionPrimitive.Content
                  asChild
                  className={styles.accordionItemContentWrapper}
                >
                  <div className={styles.accordionItemContentAlignment}>
                    <div
                      className={styles.accordionItemContent}
                      dangerouslySetInnerHTML={{ __html: item.content || "" }}
                    ></div>
                  </div>
                </AccordionPrimitive.Content>
              )}
            </AccordionPrimitive.Item>
          );
        })}
      </AccordionPrimitive.Root>
    </div>
  );
};

export interface AccordionProps {
  accordionItems: {
    icon?: ElementType;
    iconUrl?: string;
    title?: string;
    content?: string;
    children?: ReactNode;
    onCollapseChanged?: (title: string) => void;
  }[];
}
